// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"1f35036d","165":"47862a99","338":"7ae35b8b","441":"1db116ce","669":"47862a99","721":"7ae35b8b","825":"6af3184b","887":"acaaca99"}[chunkId] + ".chunk.css";
};